import myDetails from "../assets/myDetails.json";

function Footer() {
    return (
        <div className="footer">
            <div className='footer-links'>
                <div>Last updated: {myDetails?.today_date?.month} {myDetails?.today_date?.date}, {myDetails?.today_date?.year}</div>
            </div>
            <div className='footer-links'>
                <div>Design inspirations from</div>
                <a className='des-link' href='https://s3gfault.dev/' target='_blank' rel="noopener noreferrer">s3gfault.dev</a>
                <a className='des-link' href='https://flext.dev/' target='_blank' rel="noopener noreferrer">flext.dev</a>
            </div>
        </div>
    );
}

export default Footer;